
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 5h11v11l-.281.313L14.5 28.407l-.719-.688-9.5-9.5-.688-.719.688-.688L15.687 5.281zm.844 2L6.406 17.5l8.094 8.094L25 15.156V7h-8.156zM22 9a1 1 0 110 2 1 1 0 010-2z"}})])
          )
        }
      }
    